import { useTranslation } from 'react-i18next';
import { useLocation } from 'wouter';
import {
  ReactComponent as BackwardBreadCrumpIcon,
} from '../../assets/icons/Button-Control icons/Breaccrumb back button.svg';
import { useSiteInfo } from '../../shared/appUIFramework/appBackend/useSiteInfo';
import AppContentToolbar from '../../shared/appUIFramework/components/AppContentToolbar';
import AppShowLoading from '../../shared/appUIFramework/components/AppShowLoading';
import SystemForm from './components/SystemForm';
import { useAddressBook } from '../../shared/appUIFramework/appBackend/useAddressBook';
import { useEntryOrSoloSystemRoute } from '../../shared/appShellComponents/AppRouteSwitch';

export default function System() {
  const { t } = useTranslation();

  const [, params] = useEntryOrSoloSystemRoute('/systems/:siteId');
  const { siteInfo } = useSiteInfo(params?.siteId || '');

  const [, setLocation] = useLocation();
  const goToSystemsSystemDetailsPage = () => setLocation(`/systems/${params?.siteId}/system-details`);

  // preload address book for entry user form
  useAddressBook(siteInfo);

  return (
    <>
      <AppContentToolbar>
        <AppShowLoading
          inline
          showLoading={!siteInfo}
        >
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
          <span className="app-toolbar-breadcrumb-separator app-hover-pointer" onClick={goToSystemsSystemDetailsPage}><BackwardBreadCrumpIcon /></span>
          <span className="app-toolbar-breadcrumb">{t('Solo_PaxtonEntry')}</span>
          <span className="app-toolbar-breadcrumb-separator app-rotate-svg-180"><BackwardBreadCrumpIcon /></span>
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
          <span className="app-toolbar-breadcrumb app-hover-pointer" onClick={goToSystemsSystemDetailsPage}>{ siteInfo?.siteName }</span>
          <span className="app-toolbar-breadcrumb-separator app-rotate-svg-180"><BackwardBreadCrumpIcon /></span>
          <span className="app-toolbar-breadcrumb">{ t('SiteAdd_EditSystemDetails') }</span>
        </AppShowLoading>
      </AppContentToolbar>
      <SystemForm siteId={params?.siteId} goBack={goToSystemsSystemDetailsPage} />
    </>
  );
}
